import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { buildI18nResources } from './utils/i18nResourceBuilder';
import provider from './i18n/provider.runtime';
import { getAvailableLangs } from './availableLangs';

export const defaultNS = 'translation';
const rawTranslations = provider.getTranslations();
export const resources = buildI18nResources(rawTranslations);

const availableLangs = getAvailableLangs();
const isEnglishOnlyUi = availableLangs.length === 1 && availableLangs[0] === 'en';

i18n.use(initReactI18next)
    .use(
        new LanguageDetector(null, {
            lookupLocalStorage: 'lang',
            convertDetectedLanguage: lang => lang.match(/^([a-z]{2,3})(?:-|$)/i)?.[1] as string,
        }),
    )
    .init({
        resources,
        fallbackLng: isEnglishOnlyUi ? 'en' : provider.getFallbackLng(),
        defaultNS,
        interpolation: {
            prefix: '{',
            suffix: '}',
            escapeValue: false,
        },
        returnNull: false,
    });

export default i18n;
